import { Component, Input, OnChanges, ViewEncapsulation } from '@angular/core';
import { IconName } from './icon.type';

@Component({
    selector: 'app-mb-icon',
    templateUrl: './mb-icon.component.html',
    styleUrls: ['./mb-icon.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class MbIconComponent implements OnChanges {
    @Input() color: 'primary' | 'accent' | 'warn' | '' = 'primary';
    @Input() icon: IconName = 'admin';
    @Input() size: 'sm' | 'md' | 'lg' = 'md';
    @Input() width!: string;
    @Input() height!: string;
    @Input() svgColor!: string;
    @Input() cursor = false;

    cssClass!: string;

    ngOnChanges() {
        this.generate();
    }

    generate() {
        if (!this.width && !this.height) {
            this.width = this.height =
                this.size === 'lg'
                    ? '2rem'
                    : this.size === 'sm'
                    ? '1rem'
                    : '1.5rem';
        }
    }
}
